import { useLayoutEffect } from "react";
import { useOutletContext } from "react-router-dom";
import ContactSupport from "../../../../Diathrive/src/containers/ContactSupport";

const ContactSupportFlow = () => {
  const { setHeaderName } = useOutletContext();

  useLayoutEffect(() => {
    if (setHeaderName) setHeaderName("Contact Support");
  }, [setHeaderName]);

  return <ContactSupport />;
};

export default ContactSupportFlow;
